import type * as Schema from "./schema";
import { Article, articleFields } from "./article";
import { SEOPageData } from "./seoPageData";

export type Insight = Article<Schema.Insight> & SEOPageData;

export const insightFields = articleFields;

export const insightTypeLiteral: `"${Schema.Insight["_type"]}"` = '"insight"';
